import { AppError } from "./appError.js";
export class NoDossiernameProvided extends AppError {
    status = 400;
    message = "No valid dossierName was provided.";
    code = "dossier/name-invalid";
}
export class MissingParameter extends AppError {
    status = 400;
    message = "Provide a dossierName or a dossierOwner";
    code = "dossier/missing-parameter";
}
export class NotAllowedToCreate extends AppError {
    status = 403;
    message = "The user is not allowed to create a dossier.";
    code = "dossier/creation-not-allowed";
}
export class CantCreateWithoutAgency extends AppError {
    status = 403;
    message = "The user can't create a dossier without an agency.";
    code = "dossier/creation-without-agency-not-allowed";
}
export class DossierNotFound extends AppError {
    status = 404;
    message = "The requested dossier couldn't be found.";
    code = "dossier/not-found";
}
export class EditingOwnerOfDossierNotAllowed extends AppError {
    status = 403;
    message = "Editing the owner of the dossier is not allowed.";
    code = "dossier/editing-owner-not-allowed";
}
export class UserCantBeOwner extends AppError {
    status = 403;
    message = "The provided user is not allowed to be owner of the dossier.";
    code = "dossier/user-not-allowed-to-be-owner";
}
export class DocumentNotFound extends AppError {
    message = "Document not found";
    status = 404;
    code = "document/not-found";
}
